import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { WRAPPER_TO_PROVIDER_EVENT_TYPES } from '@/features/event-handlers/wrapper-event-handlers/provider-events/types';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { Provider } from '@/features/game-context/types';
import { initFusion } from '@/features/game-window-integration/helpers/fusion/init';

export const useFusionEventHandlers = () => {
  const { initialized, provider, providerRef, region } =
    useSelector(gameContextSelector);
  const fusionRef = useRef<FusionGlobal | null>(null);

  useEffect(() => {
    if (
      !initialized ||
      !providerRef ||
      !region ||
      fusionRef.current ||
      provider !== Provider.FUSION
    ) {
      return;
    }

    (async () => {
      const f = await initFusion({ gameCode: providerRef, region });
      if (f) fusionRef.current = f;
    })();
  }, [initialized, provider, providerRef, region]);

  const wrapperEventHandler = useCallback((event: MessageEvent) => {
    const fusion = fusionRef.current;
    if (event.data.type === WRAPPER_TO_PROVIDER_EVENT_TYPES.TOGGLE_AUDIO) {
      if (event.data.payload) {
        fusion?.soundEnable();
      } else {
        fusion?.soundDisable();
      }
    }
    if (event.data.type === WRAPPER_TO_PROVIDER_EVENT_TYPES.RELOAD_BALANCE) {
      fusion?.updateBalance(event.data.payload);
    }

    if (event.data.type === WRAPPER_TO_PROVIDER_EVENT_TYPES.AUTO_SPIN_STOP) {
      fusion?.stopAutoplay();
    }
  }, []);

  const providerEventHandler: () => void = () => {};

  return { wrapperEventHandler, providerEventHandler };
};
